import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {FormFieldProps} from '../../../../common/types/components';
import CalculatorSectionView from '../../../components/views/mx/turboCash/CalculatorSectionView';

const mapStateToProps = (state, {match, showErrors}) => {
    const personal = state.turboCash.loanApplication.applicantPersonal;
    const personalDataStepViewFieldErrorState = state.turboCash.ui.personalDataStepView.fieldErrors;
    const calculatorStepViewState = state.turboCash.ui.calculatorStepView.fieldErrors;
    const {turboCash: {calculator}, catalogs} = state;
    const quotas = calculator.quotas && calculator.quotas.length > 0 ? calculator.quotas[0] : {};

    return {
        calculator,
        catalogs,
        showErrors,
        firstNameField: new FormFieldProps(
            personal.firstName, personalDataStepViewFieldErrorState.firstNameFieldError),
        secondNameField: new FormFieldProps(
            personal.secondName, personalDataStepViewFieldErrorState.secondNameFieldError),
        lastNameField: new FormFieldProps(
            personal.lastName, personalDataStepViewFieldErrorState.lastNameFieldError),
        secondLastNameField: new FormFieldProps(
            personal.secondLastName, personalDataStepViewFieldErrorState.secondLastNameFieldError),
        priceField: new FormFieldProps(
            calculator.price, calculatorStepViewState.priceFieldError),
        downPaymentField: new FormFieldProps(
            calculator.downPayment, calculatorStepViewState.downPaymentFieldError),
        monthlyPaymentField: new FormFieldProps(
            calculator.monthlyPayment, calculatorStepViewState.monthlyPaymentFieldError),
        monthlyPayments: quotas.monthlyPayments,
        financingAmount: quotas.financingAmount,
        loanApplicationToken: match.params.token
    };
};

const mapDispatchToProps = (dispatch) => {
    return {};
};

const mergeProps = (stateProps, dispatchProps) => {
    const {monthlyPayments, monthlyPaymentField} = stateProps;
    return {
        ...stateProps,
        ...dispatchProps,
        monthlyPayment: monthlyPayments ? monthlyPayments.find(item => monthlyPaymentField.value.id === item.id) : {}
    };
};

const CalculatorSectionContainer = withRouter<any, any>(connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(CalculatorSectionView));

export default CalculatorSectionContainer;